import * as React from "react";
import SelectData from "./global/SelectData";
import { SelectOption } from "./global/SelectBase";

const usTimezones: SelectOption[] = [
  { label: "Eastern Time", value: "America/New_York" },
  { label: "Central Time", value: "America/Chicago" },
  { label: "Mountain Time", value: "America/Denver" },
  { label: "Pacific Standard Time", value: "America/Los_Angeles" },
  { label: "Alaska Standard Time", value: "America/Anchorage" },
  { label: "Hawaii-Aleutian Standard Time", value: "Pacific/Honolulu" },
];

const SelectTimezone = ({
  onChange,
  sx,
  value,
  label = "Timezone",
  error,
  helperText,
}: {
  onChange: (arg?: string) => void;
  sx?: any;
  value: string;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  return (
    <SelectData
      options={usTimezones}
      value={value}
      onChange={(value) => onChange(value as string)}
      label={label}
      error={error}
      helperText={helperText}
      sx={sx}
    />
  );
};
export default SelectTimezone;
